(function () {
  function splitLetters(line, offset) {
    var text = line.textContent;
    line.textContent = '';
    var index = offset;
    Array.from(text).forEach(function (char) {
      if (char === ' ') {
        var gap = document.createElement('span');
        gap.className = 'op-bp__espacio';
        gap.setAttribute('aria-hidden', 'true');
        line.appendChild(gap);
        return;
      }
      var span = document.createElement('span');
      span.className = 'op-bp__letra';
      span.setAttribute('aria-hidden', 'true');
      span.style.setProperty('--i', index++);
      span.textContent = char;
      line.appendChild(span);
    });
    return index;
  }

  function init(banner) {
    var marca = banner.querySelector('[data-op-bp-onda]');
    if (!marca || marca.dataset.opBpListo) return;
    marca.dataset.opBpListo = 'true';

    var offset = 0;
    marca.querySelectorAll('[data-op-bp-linea]').forEach(function (line) {
      offset = splitLetters(line, offset);
    });

    if (!('IntersectionObserver' in window)) {
      banner.setAttribute('data-op-bp-activo', '');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          banner.setAttribute('data-op-bp-activo', '');
        } else {
          banner.removeAttribute('data-op-bp-activo');
        }
      });
    });
    observer.observe(banner);
  }

  function initAll() {
    document.querySelectorAll('.op-bp').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
